import {
  RentalProtectionOption,
  SalesStaffOption,
  ShiftOption,
} from '../types/cart-state';
import { RentalProtectionType } from '../types/checkout-common';
import { TextGroupItemCSSClass } from '../types/common';
import { v4 as uuid } from 'uuid';

export const DELIVERY_FEE = 160;
export const PICKUP_FEE = 160;

export const rentalProtections: RentalProtectionOption[] = [
  {
    type: RentalProtectionType.STANDARD,
    title: 'Standard rental protection',
  },
  {
    type: RentalProtectionType.SELF,
    title: 'My own rental insurance',
  },
];

export const shifts: ShiftOption[] = [
  {
    id: uuid(),
    title: [
      { content: 'Up to 8 hours', cssClass: TextGroupItemCSSClass.SHIFT_TITLE },
      { content: '(per day)', cssClass: TextGroupItemCSSClass.SHIFT_TITLE_APPEND },
    ],
    description: 'Standard',
    valueAccessKey: 'Single',
  },
  {
    id: uuid(),
    title: [
      { content: '8 - 16 hours', cssClass: TextGroupItemCSSClass.SHIFT_TITLE },
      { content: '(per day)', cssClass: TextGroupItemCSSClass.SHIFT_TITLE_APPEND },
    ],
    valueAccessKey: 'Double',
  },
  {
    id: uuid(),
    title: [
      { content: 'Over 16 hours', cssClass: TextGroupItemCSSClass.SHIFT_TITLE },
      { content: '(per day)', cssClass: TextGroupItemCSSClass.SHIFT_TITLE_APPEND },
    ],
    valueAccessKey: 'Triple',
  },
];

export const SAMPLE_ES_EMAIL = 'sample@equipmentshare.com';
export const ES_EMAIL_DOMAIN = '@equipmentshare.com';

export enum SalesStaffOptionAction {
  SELECTED = "SELECTED",
  NOT_SELECTED = "NOT_SELECTED",
}

export const salesStaffOptions: SalesStaffOption[] = [
  {
    id: uuid(),
    title: 'cart.salesStaffEmailOption.notSelected.value',
    description: 'cart.salesStaffEmailOption.notSelected.description',
    action: SalesStaffOptionAction.NOT_SELECTED,
  },
  {
    id: uuid(),
    title: 'cart.salesStaffEmailOption.selected.value',
    description: 'cart.salesStaffEmailOption.selected.description',
    action: SalesStaffOptionAction.SELECTED,
  },
];
